import React, { useContext } from "react";
import { ProductContext } from "../../../context/product-context/productContext";
import Info from "../../../ui/widgets/info";
import { useMessageSource } from "react-message-source";
import Typography from "../../../ui/widgets/typography";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import useTurnoverBonusSpending from "./useTurnoverBonusSpending";
import { ScdAccordion } from "../../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../../ui/widgets/accordion/details";

const TurnoverBonus = (): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { selectedProduct } = useContext(ProductContext);

  const getTurnoverBonus = () => {
    if (selectedProduct?.hasFeature("TURNOVER_BONUS_LOW")) {
      return "TURNOVER_BONUS_LOW";
    } else if (selectedProduct?.hasFeature("TURNOVER_BONUS_HIGH")) {
      return "TURNOVER_BONUS_HIGH";
    }

    return null;
  };
  const turnoverBonus = getTurnoverBonus();

  const { lowSpending, highSpending } = useTurnoverBonusSpending(turnoverBonus);

  return (
    turnoverBonus && (
      <>
        <Info title={getMessage("TurnoverBonus.Info.title")}>
          {getMessage("TurnoverBonus.Info.text")}
        </Info>
        <ScdAccordion>
          <ScdAccordionSummary>
            <Typography variant="body2">
              {getMessage("TurnoverBonus.Benefits.title")}
            </Typography>
          </ScdAccordionSummary>
          <ScdAccordionDetails>
            <TypographyContainer>
              <TypographyItemContainer>
                <Typography variant="body2">
                  {getMessage(
                    "TurnoverBonus.Benefits.low-spending",
                    lowSpending,
                  )}
                </Typography>
              </TypographyItemContainer>
              <TypographyItemContainer>
                <Typography variant="body2">
                  {getMessage(
                    "TurnoverBonus.Benefits.high-spending",
                    highSpending,
                  )}
                </Typography>
              </TypographyItemContainer>
            </TypographyContainer>
          </ScdAccordionDetails>
        </ScdAccordion>
        <ScdAccordion>
          <ScdAccordionSummary>
            <Typography variant="body2">
              {getMessage("TurnoverBonus.Notes.title")}
            </Typography>
          </ScdAccordionSummary>
          <ScdAccordionDetails>
            <Typography variant="body2">
              {getMessage("TurnoverBonus.Notes.text")}
            </Typography>
          </ScdAccordionDetails>
        </ScdAccordion>
      </>
    )
  );
};

export default TurnoverBonus;
